import { FlowScreen } from "../../../models/AtticusScreenFlow";
import { OUTCOMES } from "../../../constants";
import { DataAPI, DataSources } from "../../../apis/data";

// import { Outcomes as RoleOutcomes, RoleScreen } from "../shared/RoleScreen";
import { NameScreen } from "../shared/NameScreen";
import { AddressScreen } from "../shared/AddressScreen";
import { AttorneyBarNumScreen } from "./AttorneyBarNumScreen";
import { BizNameScreen } from "./BizNameScreen";
import { PhoneScreen } from "../shared/PhoneScreen";
// import { EmailScreen } from "./EmailScreen";
// import { BizAddressScreen } from "./BizAddressScreen";
// import { BizPhoneScreen } from "./BizPhoneScreen";
import { BizEmailScreen } from "./BizEmailScreen";
import { BizExecutorName } from "./BizExecutorNameScreen";
import { BizContactInfo } from "./BizContactInfoScreen";
// import { DeceasedNameScreen } from "./DeceasedNameScreen";
import { EstateAddressScreen } from "./EstateAddressScreen";
import { EstateAddressUnknownScreen } from "./EstateAddressUnknownScreen";
import { ProbateCourtScreen } from "./ProbateCourtScreen";
import {
  Outcomes as OwnPropertyOutcomes,
  EstateProperty,
} from "./EstateProperty";
import { AdditionalProperty } from "./AdditionalPropertyScreen";
import { DateOfBirth } from "./DateOfBirthScreen";
import { DateOfDeath } from "./DateOfDeath";
import {
  ReceivedLetters,
  Outcomes as ReceivedLettersOutcome,
} from "./ReceivedLettersScreen";
import { DateReceivedLetter } from "./DateReceivedLetterScreen";
import { CourtCaseNumber } from "./CourtCaseNumberScreen";
import { PublishNotice } from "./PublishNoticeScreen";
import { Typography } from "@mui/material";

export enum Sections {
  AboutYou = "About You",
  AboutEstate = "About the estate",
  Publish = "Publish the notice",
}
export enum Screens {
  Role = "Role",
  ExecutorName = "ExecutorName",
  ExecutorAddress = "ExecutorAddress",
  ExecutorPhone = "ExecutorPhone",
  ExecutorEmail = "ExecutorEmail",
  DeceasedName = "DeceasedName",
  AttorneyName = "AttorneyName",
  BarNum = "BarNum",
  BizName = "BizName",
  BizAddress = "BizAddress",
  BizPhone = "BizPhone",
  BizEmail = "BizEmail",
  BizExecutorName = "BizExecutorName",
  BizContactInfo = "BizContactInfo",
  EstateAddress = "EstateAddress",
  EstateAddressUnknown = "EstateAddressUnknown",
  ProbateCourt = "ProbateCourt",
  EstateProperty = "EstateProperty",
  AdditionalProperty = "AdditionalProperty",
  DateOfBirth = "DateOfBirth",
  DateOfDeath = "DateOfDeath",
  ReceivedLetters = "ReceivedLetters",
  DateReceivedLetter = "DateReceivedLetter",
  CourtCaseNumber = "CourtCaseNumber",
  PublishNotice = "PublishNotice",
}
export const screenFlow: FlowScreen[] = [
  {
    name: Screens.Role,
    section: Sections.AboutYou,
    pathSuffix: "role",
    screenComponent: <Typography>build out role screen</Typography>,
    // next: [
    //   { outcome: RoleOutcomes.executor, screen: Screens.ExecutorName },
    //   { outcome: RoleOutcomes.attorney, screen: Screens.AttorneyName },
    // ],
    next: [{ outcome: OUTCOMES.complete, screen: Screens.ExecutorName }],
    // TODO: figure out how to store data
    // data: [
    //   {
    //     source: DataSources.cognito,
    //     api: DataAPI.userPool,
    //     fields: ["group"],
    //   },
    // ],
    first: true,
  },
  {
    name: Screens.ExecutorName,
    section: [
      { answered: "executor", value: Sections.AboutYou },
      { answered: "attorney", value: Sections.AboutEstate },
    ],
    pathSuffix: "executor-name",
    screenComponent: <NameScreen role="executor" title="What is your name?" />,
    next: [{ outcome: OUTCOMES.complete, screen: Screens.ExecutorAddress }],
    // will automatically load and save data
    data: [
      {
        source: DataSources.mysql,
        api: DataAPI.usersProfile,
        fields: ["first_name", "last_name", "middle_name"],
      },
    ],
  },
  {
    name: Screens.ExecutorAddress,
    screenComponent: <AddressScreen />,
    pathSuffix: "executor-address",
    section: [
      { answered: "executor", value: Sections.AboutYou },
      { answered: "attorney", value: Sections.AboutEstate },
    ],
    data: [
      {
        source: DataSources.mysql,
        api: DataAPI.usersProfile,
        fields: ["full_address"],
      },
    ],
    next: [{ outcome: OUTCOMES.complete, screen: Screens.ExecutorPhone }],
  },
  {
    name: Screens.ExecutorPhone,
    screenComponent: <PhoneScreen title="What is your phone number?" />,
    pathSuffix: "executor-phone",
    section: [
      { answered: "executor", value: Sections.AboutYou },
      { answered: "attorney", value: Sections.AboutEstate },
    ],
    // TODO: add phone to users_profile table
    data: [
      {
        source: DataSources.mysql,
        api: DataAPI.usersProfile,
        fields: ["phone"],
      },
    ],
    next: [{ outcome: OUTCOMES.complete, screen: Screens.DeceasedName }],
  },
  // TODO: this should be part of authentication and not asked before or after
  // {
  //   name: Screens.ExecutorEmail,
  //   screenComponent: <EmailScreen />,
  //   pathSuffix: "executor-email",
  //   section: [
  //     { answered: "executor", value: Sections.AboutDeceased },
  //     { answered: "attorney", value: Sections.AboutEstate },
  //   ],
  //   next: [{ outcome: OUTCOMES.complete, screen: Screens.DeceasedName }],
  // },
  {
    name: Screens.AttorneyName,
    screenComponent: <NameScreen role="attorney" />,
    pathSuffix: "attorney-name",
    section: Sections.AboutYou,
    // NOTE: attorney user account same as executor, but will just a different role
    data: [
      {
        source: DataSources.mysql,
        api: DataAPI.usersProfile,
        fields: ["first_name", "last_name", "middle_name"],
      },
    ],
    next: [{ outcome: OUTCOMES.complete, screen: Screens.BarNum }],
  },
  {
    name: Screens.BarNum,
    // TODO: AttorneyBarNumScreen should use SingleTextForm component with bar num RegExp
    screenComponent: <AttorneyBarNumScreen />,
    pathSuffix: "bar-number",
    section: Sections.AboutYou,
    next: [{ outcome: OUTCOMES.complete, screen: Screens.BizName }],
  },
  {
    name: Screens.BizName,
    screenComponent: <BizNameScreen />,
    pathSuffix: "business-name",
    section: Sections.AboutYou,
    // TODO: create businesses mysql table to store this - should have users_id field
    data: [
      {
        source: DataSources.mysql,
        api: DataAPI.businesses,
        fields: ["name"],
      },
    ],
    next: [{ outcome: OUTCOMES.complete, screen: Screens.BizAddress }],
  },
  {
    name: Screens.BizAddress,
    screenComponent: <AddressScreen title="What is your business address?" />,
    pathSuffix: "business-address",
    section: Sections.AboutYou,
    data: [
      {
        source: DataSources.mysql,
        api: DataAPI.businesses,
        fields: ["full_address"],
      },
    ],
    next: [{ outcome: OUTCOMES.complete, screen: Screens.BizPhone }],
  },
  {
    name: Screens.BizPhone,
    screenComponent: (
      <PhoneScreen title="What is your business phone number?" />
    ),
    pathSuffix: "business-phone",
    section: Sections.AboutYou,
    data: [
      {
        source: DataSources.mysql,
        api: DataAPI.businesses,
        fields: ["phone"],
      },
    ],
    next: [{ outcome: OUTCOMES.complete, screen: Screens.BizEmail }],
  },
  {
    name: Screens.BizEmail,
    // TODO: AttorneyBarNumScreen should use SingleTextForm component with email RegExp
    screenComponent: <BizEmailScreen />,
    pathSuffix: "business-email",
    section: Sections.AboutYou,
    data: [
      {
        source: DataSources.mysql,
        api: DataAPI.businesses,
        fields: ["email"],
      },
    ],
    next: [{ outcome: OUTCOMES.complete, screen: Screens.BizExecutorName }],
  },
  {
    name: Screens.BizExecutorName,
    // TODO: use shared/NameScreen component
    screenComponent: <BizExecutorName role="attorney" />,
    pathSuffix: "business-executor-name",
    section: Sections.AboutEstate,
    next: [{ outcome: OUTCOMES.complete, screen: Screens.BizContactInfo }],
  },
  {
    name: Screens.BizContactInfo,
    screenComponent: <BizContactInfo />,
    pathSuffix: "business-contact-info",
    section: Sections.AboutEstate,
    next: [{ outcome: OUTCOMES.complete, screen: Screens.DeceasedName }],
  },
  {
    name: Screens.DeceasedName,
    screenComponent: (
      <NameScreen role="executor" title="Who is the person who passed away?" />
    ),
    pathSuffix: "deceased-name",
    section: Sections.AboutEstate,
    data: [
      {
        // TODO: figure out what record id to save to
        source: DataSources.mysql,
        api: DataAPI.estates,
        // TODO: add deceased_middle_name to estates table
        fields: [
          "deceased_first_name",
          "deceased_last_name",
          // "deceased_middle_name",
        ],
      },
    ],
    next: [{ outcome: OUTCOMES.complete, screen: Screens.EstateAddress }],
  },
  {
    name: Screens.EstateAddress,
    // TODO: use shared/AddressScreen component
    screenComponent: <EstateAddressScreen />,
    pathSuffix: "estate-address",
    section: Sections.AboutEstate,
    next: [{ outcome: OUTCOMES.complete, screen: Screens.ProbateCourt }],
  },
  {
    name: Screens.EstateAddressUnknown,
    // TODO: unknown state should be built into shared/AddressScreen component
    screenComponent: <EstateAddressUnknownScreen />,
    pathSuffix: "estate-address-unknown",
    section: Sections.AboutEstate,
    next: [{ outcome: OUTCOMES.complete, screen: Screens.ProbateCourt }],
  },
  {
    name: Screens.ProbateCourt,
    // TODO: build out a share/SingleSelectForm component
    screenComponent: <ProbateCourtScreen />,
    pathSuffix: "probate-court",
    section: Sections.AboutEstate,
    next: [{ outcome: OUTCOMES.complete, screen: Screens.EstateProperty }],
  },
  {
    name: Screens.EstateProperty,
    // TODO: use shared/RadioAndResponseForm component
    screenComponent: <EstateProperty />,
    pathSuffix: "estate-property",
    section: Sections.AboutEstate,
    next: [
      { outcome: OwnPropertyOutcomes.yes, screen: Screens.AdditionalProperty },
      { outcome: OwnPropertyOutcomes.no, screen: Screens.DateOfBirth },
      { outcome: OwnPropertyOutcomes.dont_know, screen: Screens.DateOfBirth },
    ],
  },
  {
    name: Screens.AdditionalProperty,
    // TODO: use Address component? or keep this custom?
    screenComponent: <AdditionalProperty />,
    pathSuffix: "additional-property",
    section: Sections.AboutEstate,
    next: [{ outcome: OUTCOMES.complete, screen: Screens.DateOfBirth }],
  },
  {
    name: Screens.DateOfBirth,
    // TODO: use shared/SingleDateForm component
    screenComponent: <DateOfBirth />,
    pathSuffix: "date-of-birth",
    section: Sections.AboutEstate,
    next: [{ outcome: OUTCOMES.complete, screen: Screens.DateOfDeath }],
  },
  {
    name: Screens.DateOfDeath,
    // TODO: use shared/SingleDateForm component
    screenComponent: <DateOfDeath />,
    pathSuffix: "date-of-death",
    section: Sections.AboutEstate,
    next: [{ outcome: OUTCOMES.complete, screen: Screens.ReceivedLetters }],
  },
  {
    name: Screens.ReceivedLetters,
    // TODO: use shared/RadioAndResponseForm component
    screenComponent: <ReceivedLetters />,
    pathSuffix: "probate-court-letters",
    section: Sections.AboutEstate,
    next: [
      {
        outcome: ReceivedLettersOutcome.yes_administration,
        screen: Screens.DateReceivedLetter,
      },
      {
        outcome: ReceivedLettersOutcome.yes_testament,
        screen: Screens.DateReceivedLetter,
      },
      { outcome: ReceivedLettersOutcome.no, screen: Screens.CourtCaseNumber },
    ],
  },
  {
    name: Screens.DateReceivedLetter,
    // TODO: use shared/SingleDateForm component
    screenComponent: <DateReceivedLetter />,
    pathSuffix: "date-received-letter",
    section: Sections.AboutEstate,
    next: [{ outcome: OUTCOMES.complete, screen: Screens.CourtCaseNumber }],
  },
  {
    name: Screens.CourtCaseNumber,
    // TODO: break this into two screens - radio, then text entry
    screenComponent: <CourtCaseNumber />,
    pathSuffix: "court-case-number",
    section: Sections.Publish,
    next: [{ outcome: OUTCOMES.complete, screen: Screens.PublishNotice }],
  },
  {
    name: Screens.PublishNotice,
    // TODO: break this into two screens - radio, then text entry
    screenComponent: <PublishNotice />,
    pathSuffix: "publish-notice",
    section: Sections.Publish,
    next: [{ outcome: OUTCOMES.complete, screen: Screens.Role }],
  },
];
